<template>
  <tr class="bg-gray-50 hover:bg-gray-100 transition-colors duration-150 ease-in-out text-right child:py-4 first-child:pl-16 last-child:pr-3 text-sm">
    <td
      class="py-3 text-left"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.variationOrderCode') + ': ' + $props.variationOrder.CodeRef + ', ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.variationOrderDescription') + ': ' + $props.variationOrder.description"
    >
      <div
        class="flex items-start space-x-2"
        :style="{ paddingLeft: `${(depth * 16)}px` }"
      >
        <span class="max-w-20 font-semibold text-gray-900">{{ $props.variationOrder.CodeRef }}</span>

        <p class="w-60 text-gray-700">
          {{ $props.variationOrder.description }}
        </p>
      </div>
    </td>

    <td
      class="pr-3"
      :title="showBudgetCommentTooltip ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.budgetAmount') + ': ' + ($props.variationOrder.totalBudget ? $tcc($props.variationOrder.totalBudget) : '') + (showBudgetCommentTooltip ? ', ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showBudgetCommentButton"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          :aria-label="varianceComment ? $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editComment') : $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.addComment')"
          @click.stop="editBudgetComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <button
          v-else-if="!!varianceComment?.body"
          type="button"
          class="btn-icon btn-icon-default mr-1 shrink-0"
          @click.stop="showBudgetcomment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          <VariationOrderLinkedBudget :variation-order="$props.variationOrder" />
        </div>
      </div>
    </td>

    <td v-if="claim.boq_type === 'subcontractor_schedule_of_rates'" />

    <td
      v-if="!falsey(variationOrderCost?.current_claim) && !typingClaim && canEditClaim"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentClaim') + ': ' + (variationOrderCost.current_claim ? $tcc(variationOrderCost.current_claim) : '')"
      @click="typeClaim"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeClaim')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditClaim"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(variationOrderCost.current_claim) ? $tcc(variationOrderCost.current_claim) : '' }}
      </div>
    </td>

    <td
      v-else-if="canEditClaim"
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentClaim') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
    >
      <div class="ml-auto">
        <AppCurrencyInput
          ref="certifiedInput"
          v-model.number="costForm.form.current_claim"
          name="current_claim"
          type="number"
          min="1"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="stopTypingClaim"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentClaim') + ': ' + (variationOrderCost?.current_claim ? $tcc(variationOrderCost.current_claim) : '')"
    >
      {{ !falsey(variationOrderCost?.current_claim) ? $tcc(variationOrderCost.current_claim) : '' }}
    </td>

    <template v-if="liteMode">
      <td
        v-if="!falsey(variationOrderCost?.current_certified) && !typingCertified && canEditCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + (variationOrderCost.current_certified ? $tcc(variationOrderCost.current_certified) : '')"
        @click="typeCertified"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(variationOrderCost.current_certified) ? $tcc(variationOrderCost.current_certified) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
      >
        <div class="ml-auto">
          <AppCurrencyInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            min="1"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="stopTypingCertified"
            @keyup.esc="typingCertified = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + (variationOrderCost?.current_certified ? $tcc(variationOrderCost.current_certified) : '')"
      >
        {{ !falsey(variationOrderCost?.current_certified) ? $tcc(variationOrderCost.current_certified) : '' }}
      </td>
    </template>

    <template v-else>
      <td
        v-if="!falsey(variationOrderCost?.current_certified) && !typingCertified"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + (variationOrderCost.current_certified ? $tcc(variationOrderCost.current_certified) : '')"
        @click="typeCertified"
      >
        <div class="group flex items-center justify-end">
          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ variationOrderCost.current_certified ? $tcc(variationOrderCost.current_certified) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified && variationOrderCost?.current_claim"
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
      >
        <div class="ml-auto">
          <AppCurrencyInput
            ref="certifiedInput"
            v-model.number="costForm.form.current_certified"
            name="current_certified"
            type="number"
            min="1"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="stopTypingCertified"
            @keyup.esc="typingCertified = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-green-200/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.currentCertified') + ': ' + (variationOrderCost?.current_certified ? $tcc(variationOrderCost.current_certified) : '')"
      >
        {{ !falsey(variationOrderCost?.current_certified) ? $tcc(variationOrderCost.current_certified) : '' }}
      </td>
    </template>

    <td
      class="group bg-green-200/50"
      :class="{ 'text-red-600': hasVariance && variance !== 0 }"
      :title="hasVariance && variance !== 0 && varianceComment?.body ? varianceComment.body : ''"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.varianceAmount') + ': ' + (hasVariance ? $tcc(variance) : '') + (hasVariance && variance !== 0 && varianceComment?.body ? ', ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.varianceTooltip') + ': ' + varianceComment.body : '')"
    >
      <div class="flex items-center justify-end">
        <button
          v-if="showCommentButton"
          type="button"
          class="btn-icon group-hover:visible btn-icon-default invisible mr-1 shrink-0"
          aria-label="Edit variance comment"
          @click.stop="editVarianceComment"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M8.625 9.75a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 01.778-.332 48.294 48.294 0 005.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
    />
</svg>
        </button>

        <div class="min-w-0">
          {{ hasVariance ? $tcc(variance) : '' }}
        </div>
      </div>
    </td>

    <td
      class="bg-green-200/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.previousAmount') + ': ' + $tcc(variationOrder.previous(claim))"
    >
      {{ $tcc(variationOrder.previous(claim)) }}
    </td>

    <td
      class="bg-green-200/50 pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.cumulativeAmount') + ': ' + $tcc(variationOrder.previous(claim) + (variationOrderCost?.current_certified || 0))"
    >
      {{ $tcc(variationOrder.previous(claim) + (variationOrderCost?.current_certified || 0)) }}
    </td>

    <td
      v-if="showPercentages && !falsey(variationOrderCost?.current_claim) && !typingClaim && canEditClaim && variationOrder.totalBudget"
      :class="{ 'cursor-pointer': canEditClaim }"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.claimPercentage') + ': ' + (variationOrderCost?.current_claim ? `${$tn((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '')"
      @click="typeClaimPercent"
    >
      <div class="group flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeClaim')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
            @click.stop.capture="removeClaim">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <button
          v-if="canEditClaim"
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>
        {{ !falsey(variationOrderCost?.current_claim) ? `${$tn((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '' }}
      </div>
    </td>

    <td
      v-else-if="showPercentages && canEditClaim && variationOrder.totalBudget"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.claimPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editClaim')"
    >
      <div class="ml-auto">
        <AppInput
          ref="claimPercentInput"
          v-model.number="currentClaimPercent"
          name="current_claim_percent"
          type="number"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingClaim"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingClaim = false"
        />
      </div>
    </td>

    <td
      v-else-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.claimPercentage') + ': ' + (variationOrderCost?.current_claim && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_claim / variationOrder.totalBudget) * 100)}%` : '')"
    >
      {{ !falsey(variationOrderCost?.current_claim) && variationOrder.totalBudget ? $tp((variationOrderCost.current_claim / variationOrder.totalBudget) * 100) : '' }}
    </td>

    <td
      v-else
      class="bg-blue-100/50"
    />

    <template v-if="showPercentages && liteMode">
      <td
        v-if="!falsey(variationOrderCost?.current_certified) && !typingCertified && canEditCertified && variationOrder.totalBudget"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + (variationOrderCost?.current_certified && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_certified / variationOrder.totalBudget) * 100)}%` : '')"
        @click="typeCertifiedPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(variationOrderCost?.current_certified) && variationOrder.totalBudget ? $tp((variationOrderCost.current_certified / variationOrder.totalBudget) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified && variationOrder.totalBudget"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
      >
        <div class="ml-auto">
          <AppInput
            ref="certifiedPercentInput"
            v-model.number="currentCertifiedPercent"
            name="current_certified_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="typingCertified = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + (variationOrderCost?.current_certified && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_certified / variationOrder.totalBudget) * 100)}%` : '')"
      >
        {{ !falsey(variationOrderCost?.current_certified) && variationOrder.totalBudget ? $tp((variationOrderCost.current_certified / variationOrder.totalBudget) * 100) : '' }}
      </td>
    </template>

    <template v-else-if="showPercentages">
      <td
        v-if="!falsey(variationOrderCost?.current_certified) && !typingCertified && canEditCertified && variationOrder.totalBudget"
        :class="{ 'cursor-pointer': canEditCertified }"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + (variationOrderCost?.current_certified && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_certified / variationOrder.totalBudget) * 100)}%` : '')"
        @click="typeCertifiedPercent"
      >
        <div class="group flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-red inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.removeCertified')"
          >
            <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4"
              @click.stop.capture="removeCertified">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
          </button>

          <button
            v-if="canEditCertified"
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>
          {{ !falsey(variationOrderCost?.current_certified) && variationOrder.totalBudget ? $tp((variationOrderCost.current_certified / variationOrder.totalBudget) * 100) : '' }}
        </div>
      </td>

      <td
        v-else-if="canEditCertified && variationOrder.totalBudget && !falsey(variationOrderCost?.current_claim)"
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + $t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.editCertified')"
      >
        <div class="ml-auto">
          <AppInput
            ref="certifiedPercentInput"
            v-model.number="currentCertifiedPercent"
            name="current_certified_percent"
            type="number"
            class="w-20 h-6 ml-auto form-input"
            @blur="stopTypingCertified"
            @keyup.enter="$event.target.blur()"
            @keyup.esc="typingCertified = false"
          />
        </div>
      </td>

      <td
        v-else
        class="bg-blue-100/50"
        :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.certifiedPercentage') + ': ' + (variationOrderCost?.current_certified && variationOrder.totalBudget ? `${$tn((variationOrderCost.current_certified / variationOrder.totalBudget) * 100)}%` : '')"
      >
        {{ !falsey(variationOrderCost?.current_certified) && variationOrder.totalBudget ? $tp((variationOrderCost.current_certified / variationOrder.totalBudget) * 100) : '' }}
      </td>
    </template>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.previousPercentage') + ': ' + ($props.variationOrder.totalBudget ? $tp((previousAmount / variationOrder.totalBudget) * 100) : '')"
    >
      {{ $props.variationOrder.totalBudget ? $tp((previousAmount / variationOrder.totalBudget) * 100) : '' }}
    </td>

    <td
      v-if="showPercentages"
      class="bg-blue-100/50 pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.cumulativePercentage') + ': ' + ($props.variationOrder.totalBudget ? $tp(((previousAmount + (variationOrderCost?.current_certified || 0)) / variationOrder.totalBudget) * 100) : '')"
    >
      {{ $props.variationOrder.totalBudget ? $tp(((previousAmount + (variationOrderCost?.current_certified || 0)) / variationOrder.totalBudget) * 100) : '' }}
    </td>

    <td
      class="pr-3"
      :aria-label="$t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.accessibility.remainingBudget') + ': ' + ($props.variationOrder.totalBudget ? $tcc(variationOrder.totalBudget - variationOrder.previous(claim) - (variationOrderCost?.current_certified || 0)) : '')"
    >
      {{ $props.variationOrder.totalBudget ? $tcc(variationOrder.totalBudget - variationOrder.previous(claim) - (variationOrderCost?.current_certified || 0)) : '' }}
    </td>

    <td
      v-if="showForecasts && !typingBaselineForecast && canEditBaselineForecast"
      :class="{ 'cursor-pointer': canEditBaselineForecast }"
      class="group bg-orange-200/30 relative z-10"
      @click="typeBaselineForecast"
    >
      <div class="flex items-center justify-end">
        <button
          type="button"
          class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
          :aria-label="'Edit Baseline Forecast'"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
        </button>

        <span class="ml-2">
          {{ australianCurrency(variationOrder.baseline_forecast_amount || 0) }}
        </span>
      </div>
    </td>

    <td
      v-else-if="showForecasts && canEditBaselineForecast"
      class="bg-orange-200/30 relative z-10"
    >
      <div>
        <AppCurrencyInput
          ref="baselineForecastInput"
          v-model.number="baselineForecastForm.form.baseline_forecast_amount"
          name="baseline_forecast_amount"
          type="number"
          min="0"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingBaselineForecast"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingBaselineForecast = false"
        />
      </div>
    </td>

    <td
      v-else
      class="bg-orange-200/30 relative z-10"
    >
      <span v-if="showForecasts">{{ australianCurrency(variationOrder.baseline_forecast_amount || 0) }}</span>
    </td>

    <td
      v-if="showForecasts && !typingActualForecast && canEditForecast"
      :class="{ 'cursor-pointer': canEditForecast }"
      class="group bg-orange-200/30 relative z-10 pr-3"
      @click="typeActualForecast"
    >
      <div class="flex flex-col items-end">
        <div class="flex items-center justify-end">
          <button
            type="button"
            class="btn-icon group-hover:visible btn-icon-blue inline-block invisible"
            :aria-label="'Edit Current Forecast'"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
</svg>
          </button>

          <span class="ml-2">
            {{ australianCurrency(props.variationOrder.actualForecastForClaim(claim)) }}
          </span>
        </div>

        <p
          v-if="props.variationOrder.previousActualForecastForClaim(claim) !== 0"
          class="text-xs"
          :class="[props.variationOrder.actualForecastForClaim(claim) - props.variationOrder.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
        >
          {{ australianCurrency(props.variationOrder.actualForecastForClaim(claim) - props.variationOrder.previousActualForecastForClaim(claim)) }} m-1
        </p>
      </div>
    </td>

    <td
      v-else-if="showForecasts && canEditForecast"
      class="bg-orange-200/30 relative z-10 pr-3"
    >
      <div class="">
        <AppCurrencyInput
          ref="actualForecastInput"
          v-model.number="actualForecastForm.form.actual_forecast_amount"
          name="forecast_amount"
          type="number"
          min="0"
          class="w-20 h-6 ml-auto form-input"
          @blur="stopTypingActualForecast"
          @keyup.enter="$event.target.blur()"
          @keyup.esc="typingActualForecast = false"
        />

        <p
          v-if="props.variationOrder.previousActualForecastForClaim(claim) !== 0"
          class="text-xs"
          :class="[props.variationOrder.actualForecastForClaim(claim) - props.variationOrder.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
        >
          {{ australianCurrency(props.variationOrder.actualForecastForClaim(claim) - props.variationOrder.previousActualForecastForClaim(claim)) }} m-1
        </p>
      </div>
    </td>

    <td
      v-else-if="showForecasts"
      class="bg-orange-200/30 relative z-10 pr-3"
    >
      <p>
        {{ australianCurrency(props.variationOrder.actualForecastForClaim(claim)) }}
      </p>

      <p
        v-if="props.variationOrder.previousActualForecastForClaim(claim) !== 0"
        class="text-xs"
        :class="[props.variationOrder.actualForecastForClaim(claim) - props.variationOrder.previousActualForecastForClaim(claim) <= 0 ? 'text-green-600' : 'text-red-600']"
      >
        {{ australianCurrency(props.variationOrder.actualForecastForClaim(claim) - props.variationOrder.previousActualForecastForClaim(claim)) }} m-1
      </p>
    </td>
  </tr>
</template>

<script setup lang="ts">
import VariationOrderLinkedBudget from '@/components/shared/VariationOrderLinkedBudget.vue';
import { useFormData } from '@/composables/useFormData';
import { useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, falsey, isNumber, roundDecimals } from '@/helpers';
import { t } from '@/i18n';
import Claim, { ClaimStatus } from '@/models/Claim';
import VariationOrder, { VariationOrderStatus } from '@/models/VariationOrder';
import { useVariationOrderCostsStore } from '@/store/variationOrderCosts';
import { useVariationOrdersStore } from '@/store/variationOrders';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, useTemplateRef, watch } from 'vue';
import { toast } from 'vue3-toastify';

const props = withDefaults(
  defineProps<{
    variationOrder: VariationOrder;
    claim: Claim;
    canEditCertified: boolean;
    liteMode?: boolean;
    projectId?: string;
    showPercentages?: boolean;
    showForecasts?: boolean;
    depth?: number;
  }>(),
  {
    liteMode: false,
    depth: 0,
  },
);

const variationOrderCostsStore = useVariationOrderCostsStore();

const variationOrderCost = computed(() => {
  return variationOrderCostsStore.models.with('comments')
    .where('claim_id', props.claim.id)
    .where(
      'variation_order_id',
      props.variationOrder.id,
    ).first();
});

const typingCertified = ref(falsey(variationOrderCost.value?.current_certified));
const certifiedInput = ref();
const certifiedPercentInput = ref();

const typeCertified = () => {
  if(props.canEditCertified) {
    typingCertified.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_certified = variationOrderCost.value.current_certified;
    }

    nextTick(() => {
      certifiedInput.value?.focusInput();
    });
  }
};

const typeCertifiedPercent = () => {
  if(props.canEditCertified) {
    typingCertified.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_certified = variationOrderCost.value.current_certified;
    }

    nextTick(() => {
      certifiedPercentInput.value?.focusInput();
    });
  }
};

const previousAmount = computed(() => {
  return props.variationOrder.previous(props.claim);
});

const currentCertifiedPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_certified / props.variationOrder.totalBudget) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.variationOrder.totalBudget * 100) === 100) {
      costForm.form.current_certified = props.variationOrder.totalBudget - previousAmount.value;

      return;
    }

    costForm.form.current_certified = roundDecimals((value / 100) * props.variationOrder.totalBudget);
  },
});

const canEditClaim = computed(() => {
  return props.liteMode && props.claim.status === ClaimStatus.draft &&
    props.variationOrder.status !== VariationOrderStatus.completed;
});

const canEditCertified = computed(() => {
  return props.canEditCertified &&
    props.variationOrder.status !== VariationOrderStatus.completed;
});

const typingClaim = ref(falsey(variationOrderCost.value?.current_claim));
const claimInput = ref();
const claimPercentInput = ref();

const costForm = useFormData({
  current_certified: undefined,
  current_claim: undefined,
  comment: undefined,
});

const typeClaim = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_claim = variationOrderCost.value.current_claim;
    }

    nextTick(() => {
      claimInput.value?.focusInput();
    });
  }
};

const typeClaimPercent = () => {
  if(canEditClaim.value) {
    typingClaim.value = true;

    if(variationOrderCost.value) {
      costForm.form.current_claim = variationOrderCost.value.current_claim;
    }

    nextTick(() => {
      claimPercentInput.value?.focusInput();
    });
  }
};

const currentClaimPercent = computed({
  get() {
    return roundDecimals((costForm.form.current_claim / props.variationOrder.totalBudget) * 100) || undefined;
  },

  set(value) {
    if(value + roundDecimals(previousAmount.value / props.variationOrder.totalBudget * 100) === 100) {
      costForm.form.current_claim = props.variationOrder.totalBudget - previousAmount.value;

      return;
    }

    costForm.form.current_claim = roundDecimals((value / 100) * props.variationOrder.totalBudget);
  },
});

watch(variationOrderCost, (newValue) => {
  if(newValue) {
    costForm.setData(newValue);
  }
}, { immediate: true });

const storeSubcontractorCertifiedAction = useStoreApiAction(variationOrderCostsStore.saveSubcontractorCertified);
const storeVariationOrderCostAction = useStoreApiAction(variationOrderCostsStore.createVariationOrderCost);
const updateVariationOrderCostAction = useStoreApiAction(variationOrderCostsStore.updateVariationOrderCost);
const updateCommentAction = useStoreApiAction(variationOrderCostsStore.updateComment);
const deleteCommentAction = useStoreApiAction(variationOrderCostsStore.deleteComment);
const deleteVariationOrderCostAction = useStoreApiAction(variationOrderCostsStore.deleteVariationOrderCost);

const stopTypingClaim = async () => {
  if(
    (falsey(costForm.form.current_claim) && !variationOrderCost.value) ||
    !typingClaim.value
  ) {
    return;
  }

  if(
    variationOrderCost.value &&
    falsey(costForm.form.current_claim) &&
    falsey(variationOrderCost.value.current_certified)
  ) {
    deleteVariationOrderCostAction.request(variationOrderCost.value.id).then(() => {
      typingClaim.value = true;
    }).catch((_error) => {
      typingClaim.value = false;
    });
  } else if(variationOrderCost.value) {
    costForm.resetData(['comment']);

    if(
      !falsey(variationOrderCost.value.current_certified) &&
      costForm.form.current_claim !== costForm.form.current_certified
    ) {
      // const comment = !tradeComment ?
      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
      });
      // :
      // undefined;

      costForm.form.comment = comment?.value;

      // TODO: 10/27/23 maybe stop prompting to apply to trade

      // if(!tradeComment) {
      //   await Swal.fire({
      //     icon: 'question',
      //     title: 'Apply Comment to Trade?',
      //     showConfirmButton: true,
      //     confirmButtonText: 'Yes',
      //     showDenyButton: true,
      //   }).then((result) => {
      //     if(result.isConfirmed) {
      //       costForm.form.comment_trade_item = true;
      //     }
      //   });
      // }
    }

    updateVariationOrderCostAction.request(variationOrderCost.value.id, {
      current_claim: costForm.form.current_claim,
      comment: costForm.form.comment,
    })
      .then((_variationOrderCost) => {
        if(falsey(variationOrderCost.value.current_claim)) {
          typingClaim.value = true;
        } else {
          typingClaim.value = false;
        }
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidData'),
            text: error.data.message,
          });
        }

        costForm.form.current_claim = variationOrderCost.value.current_claim;
        typingClaim.value = false;
      });
  } else {
    storeVariationOrderCostAction.request(props.claim.id, props.variationOrder.id, costForm.form).then(
      (variationOrderCost) => {
        typingClaim.value = false;
      },
    ).catch((_error) => {
      typingClaim.value = true;
    });
  }
};

const updateLiteCertified = async () => {
  if(
    (falsey(costForm.form.current_certified) && !variationOrderCost.value) ||
    !typingCertified.value
  ) {
    return;
  }

  // if user clears certified and claim is also cleared, delete the cost
  if(
    falsey(costForm.form.current_certified) && variationOrderCost.value &&
    falsey(variationOrderCost.value.current_claim)
  ) {
    deleteVariationOrderCostAction.request(variationOrderCost.value.id).then(() => {
      typingCertified.value = false;
    }).catch((_error) => {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.somethingWentWrong'),
      });

      typingCertified.value = true;
    });
  } else if(variationOrderCost.value) {
    // if the cost exists
    costForm.resetData(['comment']);
    let commentSet = true;

    // if current certified is set and incoming new claim != current certified, require comment
    if(
      !falsey(variationOrderCost.value.current_claim) &&
      costForm.form.current_certified !== variationOrderCost.value.current_claim
    ) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    }

    if(commentSet) {
      updateVariationOrderCostAction.request(variationOrderCost.value.id, {
        current_certified: costForm.form.current_certified,
        comment: costForm.form.comment,
      })
        .then((_variationOrderCost) => {
          if(falsey(variationOrderCost.value?.current_certified)) {
            typingCertified.value = true;
          } else {
            typingCertified.value = false;
          }
        }).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidData'),
              text: error.data.message,
            });
          }

          costForm.form.current_certified = variationOrderCost.value.current_certified;

          typingCertified.value = true;
        });
    }
  } else {
    storeVariationOrderCostAction.request(props.claim.id, props.variationOrder.id, costForm.form).then(
      (variationOrderCost) => {
        typingCertified.value = false;
      },
    ).catch((error) => {
      if(error.status === 422) {
        Swal.fire({
          icon: 'error',
          title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
          text: error.data.message,
        });
      }

      typingCertified.value = true;
    });
  }
};

const updateCertified = async () => {
  if(costForm.form.current_certified !== variationOrderCost.value?.current_certified && variationOrderCost.value) {
    let commentSet = true;

    if(costForm.form.current_certified !== variationOrderCost.value?.current_claim) {
      commentSet = false;

      const comment = await Swal.fire({
        icon: 'warning',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.reasonForAdjustment'),
        text: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.dialog.varianceReasonText'),
        input: 'textarea',
        inputValue: varianceComment.value?.body ?? '',
        showCancelButton: true,
      });

      if(comment.isConfirmed) {
        commentSet = true;
      }

      costForm.form.comment = comment?.value;
    } else {
      costForm.form.comment = undefined;
    }

    if(commentSet) {
      // Save the certified amount
      storeSubcontractorCertifiedAction.request(props.projectId, props.claim.id, variationOrderCost.value.id, {
        current_certified: costForm.form.current_certified,
        comment: costForm.form.comment,
      })
        .then(
          (_variationOrderCost) => {
            // console.log('Certified amount updated:', variationOrderCost);
          },
        ).catch((error) => {
          if(error.status === 422) {
            Swal.fire({
              icon: 'error',
              title: 'Invalid data.',
              text: error.data.message,
            });
          }

          costForm.form.current_certified = variationOrderCost.value?.current_certified;
        });
    } else {
      costForm.form.current_certified = variationOrderCost.value?.current_certified;
    }
  }

  typingCertified.value = false;
};

const stopTypingCertified = async () => {
  if(props.liteMode) {
    updateLiteCertified();
  } else {
    updateCertified();
  }
};

const deleteCost = () => {
  deleteVariationOrderCostAction.request(variationOrderCost.value.id).then(() => {
    costForm.form.current_certified = undefined;
    costForm.form.current_claim = undefined;
    typingCertified.value = true;
    typingClaim.value = true;
  });
};

const removeClaim = () => {
  if(falsey(variationOrderCost.value.current_certified)) {
    deleteCost();
  } else {
    updateVariationOrderCostAction.request(variationOrderCost.value.id, { current_claim: undefined })
      .then((variationOrderCost) => {
        typingClaim.value = true;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_claim = variationOrderCost.value.current_claim;
      });
  }
};

const removeCertified = () => {
  if(!props.liteMode) {
    storeSubcontractorCertifiedAction.request(props.projectId, props.claim.id, variationOrderCost.value.id, {
      current_certified: undefined,
      comment: undefined,
    })
      .then((variationOrderCost) => {
        costForm.form.current_certified = undefined;
        typingCertified.value = true;
      }).catch((error) => {
        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_certified = variationOrderCost.value.current_certified;
      });
  } else if(falsey(variationOrderCost.value.current_claim)) {
    deleteCost();
  } else {
    updateVariationOrderCostAction.request(variationOrderCost.value.id, { current_certified: undefined })
      .then((variationOrderCost) => {
        costForm.form.current_certified = undefined;
        typingCertified.value = true;
      }).catch((error) => {
        console.log(error);

        if(error.status === 422) {
          Swal.fire({
            icon: 'error',
            title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
            text: error.data.message,
          });
        }

        costForm.form.current_certified = variationOrderCost.value.current_certified;
      });
  }
};

const varianceComment = computed(() => {
  return variationOrderCost.value?.comments[0];
});

const variance = computed(() => {
  return variationOrderCost.value?.current_claim - variationOrderCost.value?.current_certified;
});

const hasVariance = computed(() => {
  return !falsey(variationOrderCost.value?.current_claim) && !falsey(variationOrderCost.value?.current_certified);
});

const showCommentButton = computed(() => {
  return hasVariance.value && variance.value !== 0 && !!varianceComment.value && props.canEditCertified;
});

const isOptionalComment = computed(() => {
  if(!variationOrderCost.value) {
    return false;
  }

  const claim = variationOrderCost.value.current_claim;
  const certified = variationOrderCost.value.current_certified;

  if(falsey(claim) || falsey(certified)) {
    return false;
  }

  return claim === certified;
});

const showBudgetCommentButton = computed(() => {
  return props.canEditCertified && !falsey(variationOrderCost.value) &&
    !falsey(variationOrderCost.value.current_certified) &&
    !falsey(variationOrderCost.value.current_claim);
});

const showBudgetCommentTooltip = computed(() => {
  return !!varianceComment.value?.body && showBudgetCommentButton.value;
});

const showBudgetcomment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: varianceComment.value?.body,
  });
};

const editBudgetComment = () => {
  Swal.fire({
    icon: 'info',
    title: (hasVariance.value && variance.value !== 0) ? 'Reason for Adjustment' : 'Comment',
    text: (hasVariance.value && variance.value !== 0) ?
      'Please provide a reason for the variance between the claim and certified amounts.' :
      'Provide an optional comment for the cost.',

    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: varianceComment.value ? 'Update' : 'Save',
    showDenyButton: isOptionalComment.value && !!varianceComment.value,
    denyButtonText: 'Delete',
    denyButtonColor: '#d33',
  }).then((result) => {
    if(result.isDenied && varianceComment.value) {
      deleteCommentAction.request(variationOrderCost.value.id, varianceComment.value.id).then(() => {
        toast.success('Comment deleted');
      });
    } else if(result.isConfirmed && result.value) {
      if(varianceComment.value) {
        updateCommentAction.request(variationOrderCost.value.id, varianceComment.value.id, { comment: result.value })
          .then(() => {
            toast.success('Comment updated');
          });
      } else {
        updateVariationOrderCostAction.request(variationOrderCost.value.id, { comment: result.value })
          .then(() => {
            toast.success('Comment saved');
          });
      }
    }
  });
};

const editVarianceComment = () => {
  Swal.fire({
    icon: 'warning',
    title: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentTitle'),
    text: t('ClaimCertifiedCosts.TradeRowItem.alert.reasonAdjustmentText'),
    input: 'textarea',
    inputValue: varianceComment.value?.body ?? '',
    showCancelButton: true,
    confirmButtonText: 'Update',
  }).then((result) => {
    if(result.isConfirmed) {
      if(result.value) {
        updateCommentAction.request(variationOrderCost.value.id, varianceComment.value.id, { comment: result.value })
          .then(() => {
            toast.success('Comment updated');
          });
      }
    }
  });
};

const canEditForecast = computed(() => {
  return ((props.liteMode && props.claim.status === ClaimStatus.draft) ||
    props.claim.status !== ClaimStatus.certified) &&
    props.variationOrder.status !== VariationOrderStatus.completed &&
    !props.variationOrder.isTransferred;
});

const canEditBaselineForecast = computed(() => {
  // Baseline forecast can be edited when the variation order does not have a budget set
  return props.variationOrder.totalBudget === 0;
});

const variationOrdersStore = useVariationOrdersStore();
const typingBaselineForecast = ref(false);
const typingActualForecast = ref(false);

const baselineForecastForm = useFormData({
  baseline_forecast_amount: props.variationOrder.baseline_forecast_amount || 0,
});

const actualForecastForm = useFormData({
  actual_forecast_amount: props.variationOrder.actualForecastForClaim(props.claim),
});

const baselineForecastInput = useTemplateRef('baselineForecastInput');
const actualForecastInput = useTemplateRef('actualForecastInput');
const updateBaselineForecastAction = useStoreApiAction(variationOrdersStore.updateBaselineForecast);
const updateForecastAmountsAction = useStoreApiAction(variationOrdersStore.updateForecastAmounts);

const getBaselineForecastValue = () => {
  return props.variationOrder.baseline_forecast_amount || 0;
};

const typeBaselineForecast = () => {
  if(canEditBaselineForecast.value) {
    typingBaselineForecast.value = true;

    baselineForecastForm.setData({
      baseline_forecast_amount: getBaselineForecastValue(),
    });

    nextTick(() => {
      baselineForecastInput.value?.focusInput();
    });
  }
};

const typeActualForecast = () => {
  if(canEditForecast.value) {
    typingActualForecast.value = true;

    actualForecastForm.setData({
      actual_forecast_amount: props.variationOrder.actualForecastForClaim(props.claim),
    });

    nextTick(() => {
      actualForecastInput.value?.focusInput();
    });
  }
};

const stopTypingBaselineForecast = async () => {
  if(
    (falsey(baselineForecastForm.form.baseline_forecast_amount) && getBaselineForecastValue() === 0) ||
    !typingBaselineForecast.value
  ) {
    typingBaselineForecast.value = false;
    baselineForecastForm.form.baseline_forecast_amount = getBaselineForecastValue();

    return;
  }

  updateBaselineForecastAction.request(props.variationOrder.id, {
    baseline_forecast_amount: baselineForecastForm.form.baseline_forecast_amount,
  }).then(() => {
    typingBaselineForecast.value = false;
  }).catch((error) => {
    if(error.status === 422) {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
        text: error.data.message,
      });
    }

    baselineForecastForm.form.baseline_forecast_amount = getBaselineForecastValue();
    typingBaselineForecast.value = true;
  });
};

const stopTypingActualForecast = async () => {
  if(
    (falsey(actualForecastForm.form.actual_forecast_amount) &&
      props.variationOrder.actualForecastForClaim(props.claim) === 0) ||
    !typingActualForecast.value
  ) {
    typingActualForecast.value = false;
    actualForecastForm.form.actual_forecast_amount = props.variationOrder.actualForecastForClaim(props.claim);

    return;
  }

  updateForecastAmountsAction.request(props.variationOrder.id, {
    actual_forecast_amount: actualForecastForm.form.actual_forecast_amount,
  }).then(() => {
    typingActualForecast.value = false;
  }).catch((error) => {
    if(error.status === 422) {
      Swal.fire({
        icon: 'error',
        title: t('HeadContract.ProgressClaimsLite.VariationOrderCostRow.error.invalidAmount'),
        text: error.data.message,
      });
    }

    actualForecastForm.form.actual_forecast_amount = props.variationOrder.actualForecastForClaim(props.claim);
    typingActualForecast.value = true;
  });
};
</script>

<style scoped></style>
